export default {
  file: '/demo/bag-6.png',
  text: 'Discover curated luxury collectibles from top creators worldwide.',
  url: 'https://clubrare.example/explore',
};
